import { getStoreMenus } from "../../../api/services/storeService";
import { DetectMobile } from "../../../mixins/detectmobile";
import {
  isMenuAvailable,
  getCurrentDate,
} from "../../../api/helpers/datetimeHelper.js";
import { logger } from "./../../../api/Logger.js";
import { parseQueryString } from "../../../api/helpers/commonHelpers.js";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
} from "../../../constans/strings.js";

export default {
  state: {
    timer: null,
    updateTime: null,
    skipUpdateTime: false,
    storeMenus: [],
    loadedMenu: false,
    currentMenuId: "DefaultMenu",
    selectedStoreMenus: [],
    dietarySelection: { Allergy: [], Intolerance: [], Preference: [] },
    selectedMenuType: null,
    crosscellViewed: {}
  },
  mutations: {
    setCrossCellPopupViewStatus(state, {menuId, isViewed}) {
      state.crosscellViewed[menuId] = isViewed;
    },
    setCurrentMenuId(state, payload) {
      localStorage.setItem("currentMenuId", payload);
    },
    setTimer(state, payload) {
      state.timer = payload;
    },
    setSkipUpdateTime(state, payload) {
      state.skipUpdateTime = payload;
    },
    setMenuLoaded(state) {
      state.loadedMenu = true;
    },
    setMenuLoading(state) {
      state.loadedMenu = false;
    },
    setUpdateTime(state, payload) {
      state.updateTime = payload;
    },
    setStoreMenus(state, payload) {
      state.storeMenus = [];
      state.storeMenus = payload;
    },
    setSelectedStoreMenus(state, payload) {
      state.selectedStoreMenus = [];
      state.selectedStoreMenus = payload;
    },
    setAllergySelected(state, selection) {
      state.dietarySelection.Allergy = selection;
    },
    setIntoleranceSelected(state, selection) {
      state.dietarySelection.Intolerance = selection;
    },
    setPreferenceSelected(state, selection) {
      state.dietarySelection.Preference = selection;
    },
    setSelectedMenuType(state, type) {
      state.selectedMenuType = type;
    },
  },
  actions: {
    async getStoreMenu(context, payload) {
      context.commit("setMenuLoading");
      getStoreMenus(payload).onSnapshot(
        async function(snapshot) {
          var storeMenus = [];
          snapshot.docs.forEach(function(doc) {
            if (doc.exists) storeMenus.push({ id: doc.id, ...doc.data() });
          });

          context.commit("setStoreMenus", storeMenus);
          context.dispatch("changeMenuState");
          context.commit("setMenuLoaded");
        },
        async function(reason) {
          logger.log(
            reason.name,
            reason.toString(),
            "/menu",
            logger.LogType.Error
          );
        }
      );
    },
    async getSelectedStoreMenu(context, payload) {
      context.commit("setMenuLoading");
      getStoreMenus(payload).onSnapshot(
        async function(snapshot) {
          var storeMenus = [];
          snapshot.docs.forEach(function(doc) {
            if (doc.exists) storeMenus.push({ id: doc.id, ...doc.data() });
          });

          context.commit("setSelectedStoreMenus", storeMenus);
          context.commit("setMenuLoaded");
        },
        async function(reason) {
          logger.log(
            reason.name,
            reason.toString(),
            "/menu",
            logger.LogType.Error
          );
        }
      );
    },
    changeMenuState(context) {
      if (context.state.timer) window.clearTimeout(context.state.timer);
      if (
        context.getters.getMenuTimeSettings &&
        context.getters.getMenuTimeSettings.length > 0 &&
        !context.getters.storeSelectionAtCheckoutMode
      ) {
        let menuTS = context.getters.getMenuTimeSettings.find((x) =>
          isMenuAvailable(
            getCurrentDate(context.getters.currentStoreDoc ? context.getters.currentStoreDoc.TimezoneIanaFormat : null),
            x
          )
        );
        if (!context.state.skipUpdateTime)
          context.commit("setUpdateTime", menuTS ? menuTS.MenuId : "DefaultMenu");

        context.dispatch("updateShoppingCartItems");
        
      }
      context.commit(
        "setTimer",
        setTimeout(() => {
          context.dispatch("changeMenuState");
        }, 30000)
      );
    },
    clearStoreMenu(context) {
      context.commit("setCurrentMenuId", "DefaultMenu");
    },
    updateShoppingCartItems(context) {
      if (!context.getters.storeSelectionAtCheckoutMode) {
        let removedItems = [];
        context.getters.cartItems.forEach((item) => {
          const categoryProduct = context.getters.getProductFromCategories(
            item.id
          );
          const product = categoryProduct
            ? context.getters.getProductById(item.id)
            : null;
          if (!product || product.Status == 3) {
            removedItems.push(item);
          }
        });
        removedItems.forEach((item) => {
          context.commit("REMOVE_CART_ITEM", { item: item });
        });
      }
    },
  },
  getters: {
    getMenuId: (state, getters) => {
      return getters.storeMenu.MenuID;
    },
    getCrossCellViewed: (state, getters) => {
      return state.crosscellViewed[getters.getMenuId];
    },
    getPapularProducts: (state, getters) => {
      const popularProducts = [];
      if (getters.storeMenu) {
        for (const category of getters.storeMenu.Categories) {
          for(const subMenuItem of category.SubMenuItems) {
            if (getters.storeMenu.Products[subMenuItem.ProductID].Status === 2) {
              popularProducts.push(subMenuItem);
            }
          }
        }
      }
      return popularProducts;
    },
    getProductById: (state, getters) => (productId) => {
      if (getters.storeMenu) return getters.storeMenu.Products[productId];
      else return null;
    },
    getProductFromCategories: (state, getters) => (productId) => {
      if (getters.storeMenu)
        return getters.storeMenu.Categories.flatMap((x) => x.SubMenuItems).find(
          (p) => p.ProductID == productId
        );
      else return null;
    },
    getAllStoreMenus(state) {
      return state.storeMenus;
    },
    storeMenu(state, getters) {
      let storeMenu = state.updateTime ? null : null;
      storeMenu = getters.storeMenuWithMenuName(getters.getSelectedMenuType);
      return storeMenu;
    },
    storeMenuWithMenuName: (state, getters) => (menuType) => {
      let storeMenu = null;
      if (state.storeMenus && state.storeMenus.length > 1) {
        storeMenu = state.storeMenus.find((p) => p.id == "DefaultMenu");
        if (!storeMenu) storeMenu = state.storeMenus[0];
        const ooMenus = state.storeMenus.filter((m) => {
          if(typeof m.Platforms === 'object') {
            return m.Platforms.AbacusOnlineOrdering == true
              && m.Platforms.OnlineOrdering == true;
          } else {
            return false;
          }
        });
        if (
          parseQueryString().menu &&
          ooMenus.some((x) => x.MenuName == parseQueryString().menu)
        ) {
          storeMenu = ooMenus.find(
            (x) => x.MenuName == parseQueryString().menu
          );
        } else if (
          menuType &&
          getters.selectedCompany &&
          getters.selectedCompany.ViewComponentConfigs &&
          getters.selectedCompany.ViewComponentConfigs.MultipleMenus &&
          state.storeMenus.some(
            (x) =>
              x.OrderTypes &&
              ((menuType == CONSTANT_ORDER_TYPE_DELIVERY &&
                x.OrderTypes.Delivery === true) ||
                (menuType == CONSTANT_ORDER_TYPE_PICKUP &&
                  x.OrderTypes.Takeaway === true) ||
                (menuType == CONSTANT_ORDER_TYPE_DINEIN &&
                  x.OrderTypes.EatIn === true))
          )
        ) {
          if (
            getters.getMenuTimeSettings &&
            getters.getMenuTimeSettings.length > 0 &&
            !getters.storeSelectionAtCheckoutMode
          ) {
            let menuTS = getters.getMenuTimeSettings.find((x) =>
              isMenuAvailable(
                getCurrentDate(getters.currentStoreDoc ? getters.currentStoreDoc.TimezoneIanaFormat : null),
                x
              )
            );
            if (menuTS) {
              switch (menuType) {
                case CONSTANT_ORDER_TYPE_DELIVERY:
                  storeMenu = state.storeMenus.find(
                    (x) => x.MenuID == menuTS.MenuId && x.OrderTypes && x.OrderTypes.Delivery === true
                  );
                  if(!storeMenu)
                  {
                    storeMenu = state.storeMenus.find(
                      (x) => x.OrderTypes && x.OrderTypes.Delivery === true
                    );
                  }
                  break;
                case CONSTANT_ORDER_TYPE_PICKUP:
                  storeMenu = state.storeMenus.find(
                    (x) => x.MenuID == menuTS.MenuId && x.OrderTypes && x.OrderTypes.Takeaway === true
                  );
                  if(!storeMenu)
                  {
                    storeMenu = state.storeMenus.find(
                      (x) => x.OrderTypes && x.OrderTypes.Takeaway === true
                    );
                  }
                  break;
                case CONSTANT_ORDER_TYPE_DINEIN:
                  storeMenu = state.storeMenus.find(
                    (x) => x.MenuID == menuTS.MenuId && x.OrderTypes && x.OrderTypes.EatIn === true
                  );
                  if(!storeMenu)
                  {
                    storeMenu = state.storeMenus.find(
                      (x) => x.OrderTypes && x.OrderTypes.EatIn === true
                    );
                  }
                  break;
              }
            } 
          }
          switch (menuType) {
            case CONSTANT_ORDER_TYPE_DELIVERY:
              storeMenu = ooMenus.find(
                (x) => x.OrderTypes && x.OrderTypes.Delivery === true
              );
              break;
            case CONSTANT_ORDER_TYPE_PICKUP:
              storeMenu = ooMenus.find(
                (x) => x.OrderTypes && x.OrderTypes.Takeaway === true
              );
              break;
            case CONSTANT_ORDER_TYPE_DINEIN:
              storeMenu = ooMenus.find(
                (x) => x.OrderTypes && x.OrderTypes.EatIn === true
              );
              break;
          }
        } else if (
          getters.getMenuTimeSettings &&
          getters.getMenuTimeSettings.length > 0 &&
          !getters.storeSelectionAtCheckoutMode
        ) {
          let menuTS = getters.getMenuTimeSettings.find((x) =>
            isMenuAvailable(
              getCurrentDate(getters.currentStoreDoc ? getters.currentStoreDoc.TimezoneIanaFormat : null),
              x
            )
          );
          if (menuTS) {
            storeMenu = ooMenus.find((x) => x.MenuID == menuTS.MenuId);
            if (!storeMenu)
              storeMenu = state.storeMenus.find((p) => p.id == "DefaultMenu");
          } else {
            storeMenu = state.storeMenus.find((p) => p.id == "DefaultMenu");
          }
          if (!storeMenu) storeMenu = state.storeMenus[0];
        }
      } else if (state.storeMenus && state.storeMenus.length == 1) {
        storeMenu = state.storeMenus[0];
      }
      return storeMenu;
    },
    getloadedMenu(state) {
      return state.loadedMenu;
    },
    selectedStoreMenus(state, getters) {
      let SushiMenu = null;
      if (state.selectedStoreMenus && state.selectedStoreMenus.length > 1) {
        SushiMenu = state.selectedStoreMenus.find((p) => p.id == "DefaultMenu");
        if (!SushiMenu) SushiMenu = state.selectedStoreMenus[0];
        const ooMenus = state.storeMenus.filter((m) => {
          if(typeof m.Platforms === 'object') {
            return m.Platforms.AbacusOnlineOrdering == true
              && m.Platforms.OnlineOrdering == true;
          } else {
            return false;
          }
        });

        if (
          parseQueryString().menu &&
          ooMenus.some((x) => x.MenuName == parseQueryString().menu)
        ) {
          SushiMenu = ooMenus.find(
            (x) => x.MenuName == parseQueryString().menu
          );
        } else if (
          DetectMobile.methods.isMobile() &&
          getters.getSelectedMenuType &&
          ooMenus.some(
            (x) => x.MenuName == getters.getSelectedMenuType
          )
        ) {
          SushiMenu = ooMenus.find(
            (x) => x.MenuName == getters.getSelectedMenuType
          );
        } else if (
          getters.getMenuTimeSettings &&
          getters.getMenuTimeSettings.length > 0 &&
          !getters.storeSelectionAtCheckoutMode
        ) {
          let menuTS = getters.getMenuTimeSettings.find((x) =>
            isMenuAvailable(
              getCurrentDate(getters.currentStoreDoc ? getters.currentStoreDoc.TimezoneIanaFormat : null),
              x
            )
          );
          if (menuTS) {
            SushiMenu = ooMenus.find((x) => x.MenuID == menuTS.MenuId);
            if (!SushiMenu)
              SushiMenu = state.selectedStoreMenus.find((p) => p.id == "DefaultMenu");
          } else {
            SushiMenu = state.selectedStoreMenus.find((p) => p.id == "DefaultMenu");
          }
          if (!SushiMenu) SushiMenu = state.selectedStoreMenus[0];
        }
      } else if (state.selectedStoreMenus && state.selectedStoreMenus.length == 1) {
        SushiMenu = state.selectedStoreMenus[0];
      }
      return SushiMenu;
    },
    getUsedLifeStyles(state, getters) {
      if (getters.getMenuLifeStyles && getters.getMenuLifeStyles.length > 0) {
        if (getters.storeMenu && getters.storeMenu.Categories) {
          var allergies = getters.getMenuLifeStyles[0].Allergy.filter((p) =>
            getters.storeMenu.Categories.some((a) =>
              a.SubMenuItems.some(
                (a2) =>
                  a2.ProductAllergy && a2.ProductAllergy.indexOf(p.Id) > -1
              )
            )
          ).map((p) => {
            return {
              ...p,
              isSelected:
                state.dietarySelection &&
                state.dietarySelection.Allergy &&
                state.dietarySelection.Allergy.some((s) => s.Id == p.Id),
            };
          });
          var intolerances = getters.getMenuLifeStyles[0].Intolerance.filter(
            (p) =>
              getters.storeMenu.Categories.some((a) =>
                a.SubMenuItems.some(
                  (a2) =>
                    a2.ProductIntolerance &&
                    a2.ProductIntolerance.indexOf(p.Id) > -1
                )
              )
          ).map((p) => {
            return {
              ...p,
              isSelected:
                state.dietarySelection &&
                state.dietarySelection.Intolerance &&
                state.dietarySelection.Intolerance.some((s) => s.Id == p.Id),
            };
          });
          var preferences = getters.getMenuLifeStyles[0].Preference.filter(
            (p) =>
              getters.storeMenu.Categories.some((a) =>
                a.SubMenuItems.some(
                  (a2) =>
                    a2.ProductPreference &&
                    a2.ProductPreference.indexOf(p.Id) > -1
                )
              )
          ).map((p) => {
            return {
              ...p,
              isSelected:
                state.dietarySelection &&
                state.dietarySelection.Preference &&
                state.dietarySelection.Preference.some((s) => s.Id == p.Id),
            };
          });
          return {
            allergies: allergies,
            intolerances: intolerances,
            preferences: preferences,
          };
        }
      }
      return {
        allergies: [],
        intolerances: [],
        preferences: [],
      };
    },
    getDietarySelection(state) {
      return state.dietarySelection;
    },
    getMenuTypes(state) {
      var types = [
        CONSTANT_ORDER_TYPE_DELIVERY,
        CONSTANT_ORDER_TYPE_DINEIN,
        CONSTANT_ORDER_TYPE_PICKUP,
      ];
      return types.filter((p) => state.storeMenus.some((s) => s.MenuName == p));
    },
    getSelectedMenuType(state) {
      return state.selectedMenuType;
    },
  },
};
